module.exports = __webpack_public_path__ + "img/whatset.5994e1d9.png";